module.exports = "<app-loading></app-loading>"


//////////////////
// WEBPACK FOOTER
// ./src/app/auth/auth-callback.component.html
// module id = ./src/app/auth/auth-callback.component.html
// module chunks = main